import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitch",
  "use": "twitch-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"twitch\"><path fill-rule=\"evenodd\" d=\"M2 0h20a2 2 0 012 2v20a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2.36 7.36l1.03-2.626v-.001h13.548v9.33l-3.985 3.983H12l-1.922 1.971H8.016v-1.969H4.36V7.36zm10.968 8.296l2.25-2.25V6.094H6.656v9.562h3.047v1.969l1.969-1.969h3.656zm0-2.953V8.72h-1.406v3.983h1.406zm-3.656 0V8.72h-1.36v3.983h1.36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol